import { useMemo } from 'react';
import {
  selectFieldValue,
  setCurrentFieldId,
  setFieldTouched,
  setFieldValidatorDelegate,
  setFieldValue,
} from '@icp/form-renderer-core';
import { useDispatch, useSelector } from '../store';
import { useIsInDesign } from '../FormRenderCtx';

export default function useField({ id }) {
  const isInDesign = useIsInDesign();
  const dispatch = useDispatch();
  const value = useSelector(selectFieldValue(id));

  const bag = useMemo(() => {
    const setTouched = () => {
      if (isInDesign) {
        // design 模式不触发任何 touched 去造成字段校验（目前只有 ListSelect 组件在直接配置了 options 的情况下
        // 在表单设计器里可以进行点选调用到这里）
        return;
      }
      dispatch(setFieldTouched({ keyPath: id, touched: true }));
    };

    const setValue = (v, language, fromUI = true) => {
      return dispatch(setFieldValue({ keyPath: id, value: v, language, fromUI }));
    };

    const setValidatorDelegate = (validator) => {
      dispatch(setFieldValidatorDelegate({ keyPath: id, validator }));
    };

    const setFocus = () => {
      dispatch(setCurrentFieldId(id));
    };

    return { setValue, setTouched, setValidatorDelegate, setFocus };
  }, [dispatch, id, isInDesign]);

  return { ...bag, value };
}
